import DashboardIcon from '@asset/dashboard.icon.svg?react';
import { RouteEnum } from '@enum/route.enum';
import { TestIdsEnum } from '@enum/test-ids.enum';

import ApartmentIcon from './assets/apartment.icon.svg?react';
import BookIcon from './assets/book.icon.svg?react';
import UserIcon from './assets/user.icon.svg?react';

export const StartupList = [
  {
    Icon: DashboardIcon,
    title: 'Go to Dashboard',
    link: RouteEnum.Dashboard.path,
    testId: TestIdsEnum.ApplicationGoDashboard,
    // description: 'Lorum ipsum dolor sit',
  },
  {
    Icon: UserIcon,
    title: 'Invite team members',
    link: RouteEnum.AccountSettings.path,
    testId: TestIdsEnum.ApplicationGoInvite,
    // description: 'Lorum ipsum dolor sit',
  },
  {
    Icon: ApartmentIcon,
    title: 'Enable integrations',
    link: RouteEnum.Integrations.path,
    testId: TestIdsEnum.ApplicationGoIntegrations,
    // description: 'Lorum ipsum dolor sit',
  },
  {
    Icon: BookIcon,
    title: 'Read Documentation',
    href: `${import.meta.env.VITE_SOURCE_DOCS}`,
    testId: TestIdsEnum.ApplicationGoDocumentation,
    // description: 'Lorum ipsum dolor sit',
  },
];

export type StartupListType = (typeof StartupList)[0];
